<template>
    <div>
        <Card shadow>
            <Row :gutter="18">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.platids" filterable placeholder="筛选所属平台" clearable multiple :max-tag-count="2">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="6">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.app_ids" filterable placeholder="选择APP盘口" multiple :max-tag-count="3" clearable>
                            <Option v-for="(item, index) in app_list.filter((item) => table.platids.includes(item.platform))" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="4">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">游戏类型:</span>
                        <Select v-model="table.params.type" filterable placeholder="选择游戏类型" clearable>
                            <Option v-for="item in select.GameType_List" :value="item.value" :label="item.name" :key="item.value">{{ item.name }}</Option>
                        </Select>
                    </label>
                </Col>
                <Col span="4">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">筛选时间:</span>
                        <DatePicker type="daterange" v-model="select.dataTime" placement="bottom-end" placeholder="筛选时间" style="width: 100%" :options="dateOptions"></DatePicker>
                    </label>
                </Col>
                <Col span="2">
                    <Button type="primary" @click="gitList" :loading="loading">
                        查询
                        <!-- <span v-if="!loading"></span>
                        <span v-else>loading..</span>-->
                    </Button>
                </Col>
            </Row>
        </Card>
        <Table border class="cenetrtable table-padding" :columns="table.columns" :data="table.data" style="margin-top: 12px" :max-height="720" @on-sort-change="sortChange" @on-column-width-resize="widthResize" @on-expand="onExpand" :row-class-name="rowClassName" @on-row-click="handleTableClick"></Table>
        <Modal v-model="imageData.show" width="950">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>子游戏: {{ imageData.app_name }} {{ getSearchData() }}</span>
            </p>
            <div>
                <div style="display: flex; justify-content: space-between">
                    <Select class="select" v-model="imageData.checkColumn" style="width: 200px" @on-change="imageIndexChange">
                        <Option v-for="(item, index) in imageData.chartSettings.labelMap" :value="index" :key="index" :label="item"></Option>
                    </Select>
                    <Select class="select" v-model="imageTypeCheck" style="width: 200px" @on-change="imageTypeChange">
                        <Option v-for="(item, index) in imageTypeList" :value="item.index" :key="index" :label="item.name" :disabled="getTypeDisabled(item)"></Option>
                    </Select>
                </div>
                <ve-histogram :data="imageData.chartData" :settings="getChartSetting()" :extend="imageData.extend" :ref="imageData.ref" v-if="imageTypeCheck == 0"></ve-histogram>
                <ve-pie :data="imageData.chartData" :settings="getChartSetting()" :extend="imageData.extend" v-else :ref="imageData.ref"></ve-pie>
            </div>
        </Modal>
    </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
export default {
    name: 'SubGameData',
    components: { publicTable },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            timestamp: 0, //响应得请求结果
            otherData: {},
            imageTypeCheck: 0,
            filterArray: ['old_bet_user_rate', 'old_bet_point_rate', 'loss_rate', 'winner_rate'],
            imageTypeList: [
                { name: '柱状图', index: 0 },
                { name: '饼状图', index: 1 }
            ],

            select: {
                GameType_List: [
                    { name: '按最后登录城市', value: 1 },
                    { name: '按注册手机城市', value: 2 }
                ],
                dataTime: [this.getCurrentZeroDay(), new Date(new Date().setHours(23, 59, 59, 59))]
            },
            colorList: ['#145b7d', '#72baa7', '#78331e', '#f05b72', '#f58220', '#4e72b8', '#f26522', '#ed1941', '#694d9f', '#00a6ac', '#225a1f', '#f2eada', '#ef5b9c', '#2a5caa', '#008792', '#1b315e', '#f7acbc', '#11264f', '#ea66a6'],
            tableTotal: {
                type: '合计',
                _disableExpand: true,
                province: '合计',
                login_count: 0,
                pay_count: 0,
                pay_sum: 0
            },
            imageData: {
                show: false,
                app_name: '',
                ref: 'subVChartImage',
                checkColumn: 'login_count',
                selectColumn: this.getColumn(false).splice(0, 3),
                options: ['#32CD32', 'rgb(244, 128, 36)'],
                extend: {
                    series: {
                        label: {
                            show: true,
                            position: 'top',
                            formatter: (v) => {
                                if (v.seriesName.includes('比')) {
                                    return this.getCustomFixed(v.value * 100) + '%'
                                } else {
                                    return v.value
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: (params) => {
                                    return this.colorList[params.dataIndex % this.colorList.length]
                                }
                            }
                        },
                        barMaxwidth: 90
                    }
                },
                chartSettings: {
                    labelMap: {
                        login_count: '登录人数',
                        pay_count: '转入人数',
                        pay_sum: '转入金额'
                    },
                    yAxisType: ['percent']
                },
                chartData: {
                    columns: ['app_name', 'login_count'],
                    rows: []
                }
            },
            //表单数据
            table: {
                params: {
                    platform: 0,
                    app_id: 0,
                    start_time: 0,
                    end_time: 0,
                    type: 1
                },
                platids: [],
                app_ids: [],
                data: [],
                dataObj: {},
                columns1: this.getColumn(false),
                columns: this.getColumn(true),
                expandId: null
            }
        }
    },
    methods: {
        getColumn(isExpand) {
            return [
                isExpand
                    ? {
                          type: 'expand',
                          width: 50,
                          // fixed: "left",
                          align: 'center',
                          render: (h, params) => {
                              return h(publicTable, {
                                  props: {
                                      row: params.row.data,
                                      columns: this.table.columns1
                                  }
                              })
                          }
                      }
                    : {
                          align: 'center',
                          width: 50,
                          // fixed: "left",
                          render: (h, params) => {
                              return h('span', '')
                          }
                      },
                {
                    type: 'index',
                    title: '序号',
                    width: 55,
                    align: 'center',
                    indexMethod: (el, val) => {
                        if (el.province == '') {
                            return ''
                        } else {
                            return el._index + 1
                        }
                    }
                },
                {
                    key: 'province',
                    align: 'center',
                    resizable: true,
                    render: (h, params) => {
                        if (!params.row.app_name) {
                            return h('span', params.row.province)
                        } else {
                            return h('span', params.row.app_name)
                        }
                    },
                    renderHeader: (h, params) => {
                        return this.renderHeader(h, '省份地区', '注册用户所在地区')
                    }
                },

                // {
                //     key: 'province',
                //     align: 'center',
                //     sortable: 'custom',
                //     resizable: true,
                //     renderHeader: (h, params) => (this).renderHeader(h, '查询条件', ''),
                // },
                {
                    key: 'login_count',
                    align: 'center',
                    sortable: 'custom',
                    resizable: true,
                    renderHeader: (h, params) => {
                        return this.renderHeader(h, '登录玩家人数', '注册用户所在地区登录玩家人数')
                    }
                },
                {
                    key: 'pay_count',
                    align: 'center',
                    sortable: 'custom',
                    resizable: true,
                    renderHeader: (h, params) => {
                        return this.renderHeader(h, '充值玩家人数', '注册用户所在地区充值玩家人数')
                    }
                },
                {
                    key: 'pay_sum',
                    align: 'center',
                    sortable: 'custom',
                    resizable: true,
                    render: (h, params) => {
                        return h('span', this.getCustomFixed(params.row.pay_sum / 10000))
                    },
                    renderHeader: (h, params) => {
                        return this.renderHeader(h, '转入金额', '注册用户所在地区充值玩家的转入金额')
                    }
                },
                isExpand
                    ? {
                          title: ' 分布图',
                          align: 'center',
                          minWidth: 80,
                          render: (h, params) => {
                              if (params.row.province && params.row.province !== '合计') {
                                  return h(
                                      'Button',
                                      {
                                          props: {
                                              size: 'small',
                                              type: 'primary'
                                          },
                                          on: {
                                              click: () => {
                                                  this.getImageData(params.row)
                                              }
                                          }
                                      },
                                      ' 分布图'
                                  )
                              } else {
                                  return h('span', '')
                              }
                          }
                      }
                    : {
                          title: ' 分布图',
                          align: 'center',
                          minWidth: 80
                      }
            ]
        },
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        widthResize(val, val1, val2) {
            let { key } = val2
            let find = this.table.columns1.find((el) => el.key == key)
            if (find) {
                find.width = val
            }
        },
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 100000)
        },
        //获取列表
        gitList() {
            if (this.loading) return
            this.table.data = []
            this.otherData = {}
            let list = []
            let allList = []
            let next = !!this.table.params.type //筛选条件
            let paramAppArray = this.getAllHttpAppid(this.table)
            let delArray = [...paramAppArray]
            if (paramAppArray) {
                this.tableTotal.login_count = 0
                this.tableTotal.pay_count = 0
                this.tableTotal.pay_sum = 0
                let httpList = []
                let allHttpList = []
                this.timestamp = new Date().getTime()
                for (let k = 0, lens = paramAppArray.length; k < lens; k++) {
                    let item = paramAppArray[k]
                    let app = this.app_list.find((el) => el.appid == item)
                    let appName = app ? app.appName : ''
                    this.table.params.start_time = this.getSecond(this.select.dataTime[0])
                    this.table.params.end_time = this.getSecond(this.select.dataTime[1], false)
                    let param = {
                        mod: 'root',
                        platid: app.platform,
                        app_id: item,
                        appName: appName,
                        timestamp: this.timestamp,
                        param: {
                            _mod: 'manager',
                            _func: 'GetActiveUserCityList',
                            _param: {
                                ...Object.assign({}, this.table.params, {
                                    platform: app.platform
                                }),
                                app_id: item
                            }
                        }
                    }

                    httpList.push(param)
                }
                if (allHttpList.length > 0) {
                    let max = Math.min(5, allHttpList.length)
                    for (let i = 0; i < max; i++) {
                        this.toNext(allHttpList, httpList, list, allList)
                    }
                } else {
                    let max = Math.min(5, httpList.length)
                    for (let i = 0; i < max; i++) {
                        this.toHttp(httpList, list)
                    }
                }
            }
        },
        async toNext(allHttpList, httpList, list, allList) {
            if (allHttpList.length > 0) {
                let param = allHttpList.shift()
                this.openTimer()
                try {
                    let result = await TransTopReq(param)
                    if (param.timestamp == this.timestamp) {
                        result._param.data.forEach((item) => {})
                    }
                } catch (error) {}
                allList.shift()
                if (allHttpList.length > 0) {
                    this.toNext(allHttpList, httpList, list, allList)
                }

                if (allList.length == 0) {
                    let max = Math.min(5, httpList.length)
                    for (let i = 0; i < max; i++) {
                        this.toHttp(httpList, list)
                    }
                }
            }
        },
        async toHttp(httpList, list) {
            if (httpList.length > 0) {
                this.openTimer()
                let param = httpList.shift()
                let appName = param.appName
                TransTopReq(param)
                    .then((res) => {
                        if (param.timestamp == this.timestamp) {
                            let data = res._param.list || []
                            let index = list.findIndex((el) => el.province == this.tableTotal.province)
                            if (index != -1) list.splice(index, 1)
                            if (data.length > 0) {
                                for (let i = 0, len = data.length; i < len; i++) {
                                    let el = data[i]
                                    this.tableTotal.login_count += el.login_count || 0
                                    this.tableTotal.pay_count += el.pay_count || 0
                                    this.tableTotal.pay_sum += el.pay_sum || 0

                                    let child = this.copyData(el)
                                    child.app_name = appName
                                    let item = list.find((element) => element.province == el.province)
                                    if (!item) {
                                        el.data = [child]
                                        list.push(el)
                                    } else {
                                        item.data.push(child)
                                        for (let key in item) {
                                            if (typeof item[key] == 'number' && key != 'province') item[key] += el[key]
                                        }
                                    }
                                }
                            }
                            this.requestCallBack(httpList, list)
                            this.toHttp(httpList, list)
                        }
                    })
                    .catch((error) => {
                        if (param.timestamp == this.timestamp) {
                            this.requestCallBack(httpList, list)
                            this.toHttp(httpList, list)
                        }
                    })
            }
        },

        requestCallBack(list, tableData) {
            let index = tableData.findIndex((el) => el.province == this.tableTotal.province)
            if (index != -1) tableData.splice(index, 1)
            if (tableData.length > 0) {
                tableData.push(this.copyData(this.tableTotal))
                this.table.data = tableData
            }
            if (list.length == 0) {
                this.closeTimer()
            }
        },

        onExpand(row, status) {
            this.expandId = row.province
            let expand = this.table.data.find((el) => el._expanded)
            if (expand) this.$set(expand, '_expanded', false)
            if (status) {
                let newEx = this.table.data.find((el) => el.province == row.province)
                if (newEx) this.$set(newEx, '_expanded', true)
            }
        },
        handleTableClick(row, index) {
            let data = this.table.data[index]
            if (this.expandId == row.province) {
                if (!data._expanded) this.expandId = null
            } else {
                this.table.data[index]['_userCheck'] = !data._userCheck
            }
        },
        rowClassName(row, index) {
            let data = this.table.data[index]
            return data._userCheck || data._expanded ? 'user-table-check' : ''
        },
        sortChange(params) {
            let find = this.table.data.find((el) => el._expanded)
            if (find) find._expanded = false
            let order = params.order == 'desc' ? 1 : -1
            let key = params.key
            this.table.data.sort((a, b) => {
                if (a.province == '') return 1
                if (b.province == '') return -1
                return a[key] * order > b[key] * order ? -1 : 1
            })
        },

        getImageData(param) {
            this.imageData.checkColumn = 'login_count'
            this.imageData.chartData.columns = ['app_name', 'login_count']
            let rows = this.copyData(param.data)
            rows.forEach((el) => {
                let find = this.table.data.find((item) => item.province == el.province)

                for (let i in el) {
                    if (i.includes('_sum') && !i.includes('_rate')) {
                        el[i] = parseFloat(this.getCustomFixed(el[i] / 10000))
                    } else if (i.includes('_rate')) {
                        el[i] = parseFloat((el[i] || 0).toFixed(4))
                    }
                }
            })
            this.sort(rows, 'login_count')
            this.imageData.chartData.rows = rows
            this.imageData.show = true
            this.imageData.app_name = param.game_name
            this.$nextTick(() => {
                this.$refs[this.imageData.ref].echarts.resize()
            })
        },
        sort(list, val) {
            list.sort((a, b) => {
                return parseFloat(a[val]) > parseFloat(b[val]) ? 1 : -1
            })
        },
        imageIndexChange(val) {
            this.imageData.chartData.columns = [this.imageData.chartData.columns[0], val]
            if (this.filterArray.includes(val)) {
                this.imageTypeCheck = 0
            }
            this.sort(this.imageData.chartData.rows, val)
            this.$refs[this.imageData.ref].echarts.resize()
        },
        getChartSetting() {
            if (this.imageData.checkColumn.includes('_rate')) {
                return this.imageData.chartSettings
            } else {
                return Object.assign({}, this.imageData.chartSettings, {
                    yAxisType: ['normal']
                })
            }
        },
        // 分布图时间
        getSearchData(isStart = true) {
            return `(${moment(this.table.params.start_time * 1000)
                .locale('zh-cn')
                .format('YYYY/MM/DD')} - ${moment(this.table.params.end_time * 1000)
                .locale('zh-cn')
                .format('YYYY/MM/DD')})`
        },
        imageTypeChange() {},
        getListDisabled(key) {
            if (this.imageTypeCheck == 0) return false
            if (this.imageTypeCheck == 1) {
                return this.filterArray.includes(key)
            }
            return false
        },
        getTypeDisabled(item) {
            return this.filterArray.includes(this.imageData.checkColumn)
        }
    },

    created() {}
}
</script>
<style lang="less">
.btn_batch {
    margin-right: 12px;
}
.cenetrtable {
    td.ivu-table-expanded-cell {
        padding: 0px !important;
    }
    .ivu-table-cell-with-expand {
        height: 30px !important;
        line-height: 30px;
    }
    .ivu-table-large {
        td {
            height: 30px !important;
        }
    }
    .ivu-table-wrapper {
        overflow: inherit !important;
    }
    .ivu-table-expanded-cell {
        padding: 0px;
    }
    .rightTop {
        position: absolute;
        right: 10px;
        top: 40px;
    }
}
</style>
